/** Redux state reducer for the application - used to power
 * the UI, but designed to be highly compatible with the
 * data types and events on the server, to enable
 * sharing of events over sockets without reformulating
 * those events.
 * NOTE: left here as a placeholder for when we need state
 */

const defaultState = {}

const reducer = (state = defaultState, action) => {
  switch (action.type) {
    default: {
      return state
    }
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/common/state/state.js